export interface QuizRouter {
  goToList(query?: string): void;
  goToDetail(id: string): void;
  goToEdit(query?: string): void;
  goToCreate(accountId: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizRouter = Symbol('QuizRouter');
